import React from 'react';
import * as PropTypes from 'prop-types';

import { DEPENDENT_FORM_STEPS } from '../../../redux/dependentForm/progress.actions';
import { roleList } from '../utils/roleList';
import RoleCard from './RoleCard';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

const DependentRole = ({ printTitle, goNext }) => {
  usePageView('Add Dependent | Role');
  const handleRoleSelect = role => {
    goNext({
      step: DEPENDENT_FORM_STEPS.ROLE,
      data: { role },
    });
  };

  return (
    <div>
      <MetaHelmet title="pages.title.dependentRole" />

      {printTitle('dependent.form.selectRoleTitle')}
      {roleList.map(({ role, id, title, translateId, disabled }) => (
        <RoleCard
          onCardClick={handleRoleSelect}
          disabled={disabled}
          text={translateId}
          title={title}
          key={id}
          id={id}
          role={role}
        />
      ))}
    </div>
  );
};

DependentRole.propTypes = {
  printTitle: PropTypes.func,
  goNext: PropTypes.func,
};

export default DependentRole;



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentRole/index.jsx